import useApiMutation from 'shared/hooks/use-api-mutation';
import {ProductProps} from '../types';
import productsKeys from '../util/products-keys';
import useQueryHelpers from 'shared/hooks/use-query-helpers';

const useEditSize = (productId: string, sizeId: string) => {
  const {setData} = useQueryHelpers();

  const onSuccess = (data: ProductProps) =>
    setData(productsKeys.details(productId), data);

  return useApiMutation<ProductProps>({
    url: `/products/${productId}/sizes/${sizeId}`,
    method: 'PATCH',
    errorTitle: 'Erro ao atualizar tamanho do produto',
    successTitle: 'Atualizar tamanho',
    successMessage: 'Tamanho do produto atualizado com sucesso',
    redirectUrl: (data) => `/menu/products/${data.id}/sizes`,
    onSuccess,
  });
};

export default useEditSize;
